// BI-RADS classification options
const OPACITIES_OPTIONS = ['lesionKnown', 'birads2', 'birads3', 'birads4', 'birads5'];
const MICROCALC_CLASSES = ['vessel', 'birads2', 'birads3', 'birads4', 'birads5'];

// BI-RADS classification keys for data processing
const BI_RADS_KEYS = ['vessel', 'birads2', 'birads3', 'birads4', 'birads5', 'lesionKnown'];

const MICROCALC_CLUSTERABLE = ['vessel', 'birads2', 'birads3'];

// Mapping for class code (used in finding ID generation)
const CLASS_MAP = {
  birads2: '2',
  birads3: '3',
  birads4: '4',
  birads5: '5',
  lesionKnown: 'lk',
  vessel: 'v',
};

const MATCHED_PROJECTION_MAP = {
  rcc: 'rmlo',
  rmlo: 'rcc',
  lcc: 'lmlo',
  lmlo: 'lcc',
};

const PROJECTION_TO_BREAST = {
  rcc: 'right',
  rmlo: 'right',
  lcc: 'left',
  lmlo: 'left',
};

const SIDES = {
  right: ['rcc', 'rmlo'],
  left: ['lcc', 'lmlo'],
};

const MODULES = [
  { key: 'customOpacities', type: 'opacities' },
  { key: 'customMicrocalc', type: 'microcalc' },
];

// Lesion type options for dropdowns
const TYPE_OPTIONS = [
  'opacities',
  'microcalc',
  // 'lymph_node',
  // 'architectural_distortion',
  // 'asymmetry',
  // 'skin_thickening',
  // 'scar',
  // 'ductal_changes',
  // 'fat_necrosis_oil_cysts',
];

// Filter options
const FILTER_TYPE_OPTIONS = ['all', 'microcalc', 'opacities'];
const FILTER_CLASS_OPTIONS = [
  'all',
  'vessel',
  'birads2',
  'birads3',
  'birads4',
  'birads5',
  'lesionKnown',
];

// Projection matching
const MATCHED_PROJECTIONS = {
  rcc: 'rmlo',
  rmlo: 'rcc',
  lcc: 'lmlo',
  lmlo: 'lcc',
};

export const quadrantMap = {
  SuperiorMedial: 'UIQ',
  SuperiorLateral: 'UOQ',
  InferiorMedial: 'LIQ',
  InferiorLateral: 'LOQ',

  MedialSuperior: 'UIQ',
  LateralSuperior: 'UOQ',
  MedialInferior: 'LIQ',
  LateralInferior: 'LOQ',

  Superior: 'U',
  Inferior: 'L',
  Medial: 'M',
  Lateral: 'O',
};

export const rightPathMap = {
  UIQ: 'M100,100 L100,10 A90,90 0 0,1 190,100 Z',
  UOQ: 'M100,100 L100,10 A90,90 0 0,0 10,100 Z',
  LIQ: 'M100,100 L190,100 A90,90 0 0,1 100,190 Z',
  LOQ: 'M100,100 L10,100 A90,90 0 0,0 100,190 Z',
  U: 'M100,100 L100,10 A90,90 0 0,1 190,100 Z M100,100 L100,10 A90,90 0 0,0 10,100 Z',
  L: 'M100,100 L190,100 A90,90 0 0,1 100,190 Z M100,100 L10,100 A90,90 0 0,0 100,190 Z',
  M: 'M100,100 L100,10 A90,90 0 0,1 190,100 Z M100,100 L190,100 A90,90 0 0,1 100,190 Z',
  O: 'M100,100 L100,10 A90,90 0 0,0 10,100 Z M100,100 L10,100 A90,90 0 0,0 100,190 Z',
};

export const leftPathMap = {
  UIQ: 'M100,100 L100,10 A90,90 0 0,0 10,100 Z',
  UOQ: 'M100,100 L100,10 A90,90 0 0,1 190,100 Z',
  LIQ: 'M100,100 L10,100 A90,90 0 0,0 100,190 Z',
  LOQ: 'M100,100 L190,100 A90,90 0 0,1 100,190 Z',
  U: 'M100,100 L100,10 A90,90 0 0,1 190,100 Z M100,100 L100,10 A90,90 0 0,0 10,100 Z',
  L: 'M100,100 L190,100 A90,90 0 0,1 100,190 Z M100,100 L10,100 A90,90 0 0,0 100,190 Z',
  M: 'M100,100 L100,10 A90,90 0 0,0 10,100 Z M100,100 L10,100 A90,90 0 0,0 100,190 Z',
  O: 'M100,100 L100,10 A90,90 0 0,1 190,100 Z M100,100 L190,100 A90,90 0 0,1 100,190 Z',
};

export const tableHeadColumns = (t) => [
  { key: 'index', label: '', align: 'left', width: '7%', borderRadius: '5px 0 0 0' },
  { key: 'type', label: t('diagnose.type'), align: 'center', width: '16%' },
  { key: 'class', label: t('diagnose.class'), align: 'center', width: '17%' },
  { key: 'size', label: t('diagnose.size'), align: 'center', width: '15%' },
  { key: 'location', label: t('diagnose.location'), align: 'center', width: '11%' },
  { key: 'trend', label: t('diagnose.trend'), align: 'center', width: '23%' },
  { key: 'actions', label: '', align: 'center', width: '6%', borderRadius: '0 5px 0 0' },
];

export const getMatchedProj = (breast) => MATCHED_PROJECTIONS[breast];

export const shouldCancelDrag = (target) => {
  const hasIdInTree = (element, id) => {
    let current = element;
    while (current) {
      if (current.id === id) return true;
      current = current.parentElement;
    }
    return false;
  };

  if (hasIdInTree(target, 'row-drag-icon')) {
    return false;
  }

  // Check for hidden overlays and backdrops first
  if (
    target?.getAttribute?.('aria-hidden') === 'true' ||
    target?.style?.zIndex === '-1' ||
    target?.style?.position === 'fixed' ||
    target?.style?.background === 'transparent'
  ) {
    return true;
  }

  // Check if the target element itself matches interactive selectors
  const isTargetInteractive = (element) => {
    if (!element) return false;

    // Direct matches for interactive elements
    const interactiveClasses = [
      'row-actions-icon',
      'MuiIconButton-root',
      'matched_icon',
      'MuiSelect-select',
      'MuiSelect-root',
      'MuiMenu-root',
      'MuiPaper-root',
      'MuiMenuItem-root',
      'MuiPopover-root',
      'MuiTypography-root',
      'type_chip',
      'diagnostics_type_chips',
      'class_chip',
      'MuiChip-root',
      'history_item_container',
      'date-link',
      'previous-finding-icon',
      'row-actions-class',
      'MuiTouchRipple-root',
    ];

    const interactiveIds = [
      'row-actions-icon',
      'row-type-change',
      'row-class-change',
      'history-chip',
      'row-unmatch-icon',
      'row-unmatch',
      'row-collapse-icon',
      'row-expand-icon',
      'row-collapse',
      'previous-finding-icon',
      'row-actions',
      'row-delete-icon',
    ];

    // Check classes
    if (interactiveClasses.some((cls) => element.classList?.contains(cls))) {
      return true;
    }

    // Check IDs
    if (interactiveIds.some((id) => element.id === id)) {
      return true;
    }

    // Check roles
    if (element.getAttribute?.('role') === 'listbox' || element.getAttribute?.('role') === 'option') {
      return true;
    }

    return false;
  };

  // Check the target element and its immediate children
  if (isTargetInteractive(target)) {
    return true;
  }

  // Check if any immediate child is interactive
  if (target?.children) {
    for (let child of target.children) {
      if (isTargetInteractive(child)) {
        return true;
      }
    }
  }

  return false;
};

export {
  OPACITIES_OPTIONS,
  MICROCALC_CLASSES,
  BI_RADS_KEYS,
  MICROCALC_CLUSTERABLE,
  CLASS_MAP,
  MATCHED_PROJECTION_MAP,
  PROJECTION_TO_BREAST,
  SIDES,
  MODULES,
  TYPE_OPTIONS,
  FILTER_TYPE_OPTIONS,
  FILTER_CLASS_OPTIONS,
};
